import React from 'react';

import styles from './LoadingDots.module.scss';

export default () => (
  <div className={styles.dots}>
    <div className={styles.dot1} />
    <div className={styles.dot2} />
    <div className={styles.dot3} />
  </div>
);
